<template>
  <div data-cy="minimal-layout" style="height: 100%">
    <svg fill="none" height="100%" width="100%" xmlns="http://www.w3.org/2000/svg">
      <defs>
        <linearGradient id="gradient">
          <stop offset="0%" stop-color="#00BCD4"/>
          <stop offset="100%" stop-color="#0D47A1"/>
        </linearGradient>
      </defs>
      <rect fill="url(#gradient)" height="100%" rx="0" ry="0" width="100%" x="0" y="0"/>
    </svg>
    <div class="top-block">
      <a href="https://check-position.com">
        <v-badge color="success" content="🙂" overlap>
          <v-icon dark size="80">mdi-layers-search-outline</v-icon>
        </v-badge>
      </a>
    </div>
    <router-view/>
    <div class="bottom-block">
      <div class="mt-12 white--text">
        {{ $t('no-account') }} <a class="white--text" href="https://check-position.com">{{ $t('inscription') }}</a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'MinimalLayout',
}
</script>

<style scoped>
.top-block {
  display: block;
  position: absolute;
  width: 100%;
  top: 0;
  text-align: center;
  padding: 13vh 40px 0 40px;
}

.bottom-block {
  display: block;
  position: absolute;
  width: 100%;
  bottom: 0;
  text-align: center;
  padding: 0 40px 5vh 40px;
}

@media (max-height: 800px) {
  .top-block {
    padding-top: 10vh
  }
}

@media (max-height: 500px) {
  .bottom-block {
    display: none;
  }
}
</style>

<i18n>
{
  "en": {
    "inscription": "Register for free !",
    "no-account": "Do not have an account yet ?"
  },
  "es": {
    "inscription": "¡Registrate gratis !",
    "no-account": "Aun no tiene una cuenta ?"
  },
  "fr": {
    "inscription": "Inscrivez-vous gratuitement !",
    "no-account": "Vous n'avez pas encore de compte ?"
  },
  "it": {
    "inscription": "Registrati gratuitamente !",
    "no-account": "Non hai ancora un account ?"
  },
  "pt": {
    "inscription": "Registe-se gratuitamente !",
    "no-account": "Ainda não tem uma conta ?"
  },
  "pl": {
    "inscription": "Zarejestruj się za darmo!",
    "no-account": "Nie masz jeszcze konta?"
  }
}
</i18n>
